import styled from "styled-components";
import colors from "../../../constants/colors";

const sizes = {
  small: "1.5rem",
  medium: "2.5rem",
  large: "4rem",
};

const containerSizes = {
  small: "40px",
  medium: "56px",
  large: "80px",
};

export const PeopleIconWrapper = styled("div")<{
  $size: "small" | "medium" | "large";
  $withBackground: boolean;
  $customStyle: boolean;
}>(({ $size, $withBackground, $customStyle }) => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",

  ...($withBackground && $customStyle
    ? {
        // Circular background with gradient
        width: containerSizes[$size],
        height: containerSizes[$size],
        borderRadius: "50%",
        background: "linear-gradient(135deg, #E9D5FF 0%, #DDD6FE 100%)",
        boxShadow: "0 4px 12px rgba(139, 92, 246, 0.25)",
      }
    : {}),

  ".MuiSvgIcon-root": {
    fontSize: sizes[$size],
    ...(($customStyle
      ? {
          // Custom purple gradient
          background: colors.GRADIENT_PURPLE,
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          backgroundClip: "text",
          filter: "drop-shadow(0 2px 4px rgba(116, 105, 182, 0.3))",
        }
      : {
          // Regular MUI styling
          color: colors.BLACK,
        }) as any),
    transition: "all 0.3s ease",
  },
}));
